import { ADD_NOTE,SET_EXP_DATA,SET_EDU_DATA,SET_PROJECT_DATA, SET_SKILLS_DATA,SET_COURSES_DATA,SET_PROFILE_DATA,SET_HOBBY_DATA } from "./constants";

export const addNote =(note)=> {
    return({
        type: ADD_NOTE,
        payload:note
    })
}

export const setExpData =(data)=> {
    return({
        type: SET_EXP_DATA,
        payload:data
    })
}

export const setEduData =(data)=> {
    return({
        type: SET_EDU_DATA,
        payload:data
    })
}

export const setProjectsData =(data)=> {
    return({
        type: SET_PROJECT_DATA,
        payload:data
    })
}

export const setSkillsData =(data)=> {
    return({
        type: SET_SKILLS_DATA,
        payload:data
    })
}

export const setCoursesData =(data)=> {
    return({
        type: SET_COURSES_DATA,
        payload:data
    })
}
export const setProfileData =(data)=> {
    return({
        type: SET_PROFILE_DATA,
        payload:data
    })
}

export const setHobbies =(data)=> {
    return({
        type: SET_HOBBY_DATA,
        payload:data
    })
}